import { render, staticRenderFns } from "./EditFunderProgramDetail.vue?vue&type=template&id=7a1e2b81"
import script from "./EditFunderProgramDetail.vue?vue&type=script&lang=js"
export * from "./EditFunderProgramDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports